module.exports = __webpack_public_path__ + "img/auth-background.c1025235.svg";